// extracted by css-extract-rspack-plugin
module.exports =  {"text":"e59b3ded19","image":"eb23db4764"};